import React from 'react'
import View from './View'

interface Props {
  score: number
}
const ScoreBar = ({ score }: Props): JSX.Element => {
  const availableColors = ['bg-errorRed', 'bg-yellow', 'bg-successGreen']
  const numColors = availableColors.length
  const colorIndex = Math.floor((score / 101) * numColors)
  return <View className={`w-4 h-22 rounded-r-2 ${availableColors[colorIndex]}`} />
}

export default ScoreBar
